// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthInterceptorService {

//   constructor() { }
// }

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, switchMap, catchError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from 'src/app/utils.service';

import { HttpClient } from '@angular/common/http';
import { SmallDialogComponent } from 'src/app/feature/small-dialog/small-dialog.component';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(public dialog: MatDialog, private utilsService: UtilsService, private http: HttpClient) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add the new header
    // const accessToken = localStorage.getItem('accessToken');
    const accessToken = this.utilsService.token;
    if (req.body instanceof FormData) {
      return next.handle(req);
    }

    let clonedRequest;
console.log("accessToken", accessToken);
    if(accessToken){
       clonedRequest = req.clone({
        headers: req.headers
          .set('Content-type', `application/json`)
          .set('Authorization', `Bearer ${accessToken}`)
          .set('Key', `Isa `)
      });
    }




    // Pass the cloned request instead of the original request to the next handler
    // return next.handle(clonedRequest);
    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 401) {

          const refreshToken = this.utilsService.refresh_token;

          return this.http.post<any>('http://localhost:3000/refresh-token', {
            refreshToken
          }).pipe(
            switchMap(res => {

              // localStorage.setItem('accessToken', res.accessToken);
              this.utilsService.token = res.token

              const newReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${res.token}`)
              });

              return next.handle(newReq);
            }),
            catchError(err => {
              // localStorage.clear();
              // window.location.href = '/login';
              // this.errorDialog(data['statusMessage'],data['supportMessage']);
              this.errorDialog("Token Expired", "Please try again...");
              return throwError(() => err);
            })
          );
        }

        return throwError(() => error);
      })
    );
  }

    errorDialog(statusMessage:any,supportMessage: any): void {
      let dialogRef = this.dialog.open(SmallDialogComponent, {
        width: '80%',
        data: { title: statusMessage, caption: ``, message: supportMessage, close_btn: '', submit_btn: 'Ok', submit_btn_clicked: false }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed', result);
        // if(result.submit_btn_clicked && result.submit_btn_clicked!=undefined){
        // // this.deleteCompany(result.data);
        // }
  
  
        // this.animal = result;
      });
    }
}

